module.exports = __webpack_public_path__ + "static/media/noBack2.4873f1b0.svg";